import React, { useEffect, useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./callibrageNew.css";
import {
  Button,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Col,
  Row,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import clsx from "clsx";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getAllClients,
  getManagersByTenant,
} from "../../../redux/actions/user";
import { getGrillesByTenant } from "../../../redux/actions/grille";
import { createCalibrage } from "../../../redux/actions/calibrage";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import fr from "date-fns/locale/fr";
import iconcalendarColor from "../../../assets/images/icon-calendar.svg";
import CloseIcon from "../../../assets/icons/CloseIcon.svg";
import Select from "react-select";
const Callibrage = (props) => {
  const reloadClibList = props.reloadClibList;
  const { isOpen, prevPage, exportpdf, status1 } = useSelector(
    (state) => state.design
  );
  const formik = useFormik({
    initialValues: {
      OrganIsEval: false,
      DateLimite: "",
      interaction: "",
      agentId: "",
      gridId: "",
      participants: [],
    },
    validationSchema: Yup.object({
      OrganIsEval: Yup.boolean().test(
        "OrganParticipValidation",
        "Choisir au moins 1 participant",
        function (value) {
          const { participants } = this.parent;
          if (value) {
            return participants.length + 1 > 0;
          } else {
            if (participants.length > 1) {
              return true;
            }
          }
        }
      ),
      DateLimite: Yup.date().required("Date limite est obligatoire"),
      interaction: Yup.string().required("Interaction est obligatoire"),
      agentId: Yup.number().required("Agent est obligatoire"),
      gridId: Yup.number().required("Grille est obligatoire"),
      participants: Yup.array()
        .required("Participants est obligatoire")
        .test("ParticipantsValidation", function (value) {
          const { OrganIsEval } = this.parent;

          if (OrganIsEval) {
            if (!value || value.length < 1) {
              return this.createError({
                message: "Choisir au moins 1 participant.",
              });
            } else if (value.length > 2) {
              return this.createError({
                message: "Choisir au maximum 2 participants.",
              });
            }
          } else {
            if (!value || value.length < 2) {
              return this.createError({ message: "Choisir 2 participants." });
            }
            if (value.length > 3) {
              return this.createError({
                message: "Choisir au maximum 3 participants.",
              });
            }
          }

          return true;
        }),
    }),
    onSubmit: async (values) => {
      setIsSaving(true);
      dispatch(createCalibrage(values)).then(() => {
        setCloseAnimation(true);

        setTimeout(() => {
          setIsSaving(false);
          props.closeCallibrage();
          props.onDisplay("none");
          props.setReloadList(!props.reloadClibList);
          history.push(currentPath);
          props.onDisplay("block");
        }, 3000);
      });
    },
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const currentPath = window.location.pathname + window.location.search;
  const { clients, client, managers } = useSelector((state) => state.user);
  const { datagrilles } = useSelector((state) => state.grille);
  const [startDate, setStartDate] = useState(null);
  const [closeAnimation, setCloseAnimation] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    fetchdata();
  }, [dispatch]);
  const fetchdata = () => {
    dispatch(getAllClients(0, 100));
    dispatch(getGrillesByTenant(0, 100));
    dispatch(getManagersByTenant());
  };
  const handleParticipantsChange = (selectedOptions) => {
    formik.setFieldValue(
      "participants",
      selectedOptions.map((option) => option.value)
    );
  };
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <InputGroup id="small-calendar" onClick={onClick}>
      <Form.Control
        style={{ paddingTop: "3px" }}
        placeholder="jj/mm/aaaa"
        defaultValue={value}
        ref={ref}
        autoComplete="off"
      />
      <div className="search-icon" style={{ marginTop: "3px" }}>
        <img src={iconcalendarColor} />
      </div>
    </InputGroup>
  ));
  return (
    <Form noValidate onSubmit={formik.handleSubmit}>
      <div
        className={clsx(
          { "callibrage-container": props.openCallibrage },
          { "callibrage-container-close": closeAnimation }
        )}
      >
        <div
          className="left-side-callibrage"
          style={{
            minHeight: window.devicePixelRatio === 1.25 ? "70vh" : "76vh",
          }}
        ></div>
        <div
          className="right-side-callibrage-nouveau"
          style={{
            minHeight: window.devicePixelRatio === 1.25 ? "70vh" : "76vh",
          }}
        >
          <div className="container-topbar-of-callibrage-nouveau">
            <h5 className="right-side-calibrage-title">NOUVEAU CALIBRAGE </h5>
            <div className="fiche-equipe-close-arrow">
              <img
                alt="CloseIcon"
                style={{ cursor: "pointer" }}
                src={CloseIcon}
                onClick={() => {
                  setCloseAnimation(true);
                  setTimeout(() => {
                    props.closeCallibrage();
                  }, 2000);
                }}
              />
            </div>
          </div>

          <Row>
            <Col xs={12} md={12} style={{ marginTop: "20px" }}>
              <div className="ty-connection-block">
                <span className="ty-connection-span">Détails calibrage</span>
              </div>
            </Col>
          </Row>

          <div className="form-callibrage-nouveau">
            <Form.Group>
              <Row>
                <Col xs={12} md={6} style={{ marginTop: "15px" }}>
                  <Form.Control
                    style={{ color: "#8A9099" }}
                    name={"interaction"}
                    type="text"
                    placeholder="Reference de I'interaction"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.interaction}
                  />
                  {formik.touched.interaction && formik.errors.interaction ? (
                    <div className="text-danger">
                      {formik.errors.interaction}
                    </div>
                  ) : null}
                </Col>
                <Col xs={12} md={6} style={{ marginTop: "15px" }}>
                  <Form.Group className="" controlId="formBasicAgent">
                    <div className="Select-wrapp">
                      <Select
                        placeholder="Liste des participants"
                        options={managers?.map((manager) => ({
                          value: manager.id,
                          label: `${manager.firstName} ${manager.lastName}`,
                        }))}
                        isMulti
                        onChange={(selectedOptions) => {
                          const values = selectedOptions
                            ? selectedOptions.map((option) => option.value)
                            : [];
                          formik.setFieldValue("participants", values);
                        }}
                        onBlur={() =>
                          formik.setFieldTouched("participants", true)
                        }
                        value={managers
                          .map((manager) => ({
                            value: manager.id,
                            label: `${manager.firstName} ${manager.lastName}`,
                          }))
                          .filter((option) =>
                            formik.values.participants.includes(option.value)
                          )}
                      />
                      {formik.touched.participants &&
                      formik.errors.participants ? (
                        <div className="text-danger">
                          {formik.errors.participants}
                        </div>
                      ) : null}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row className="marginRows">
                <Col xs={12} md={6} style={{ marginTop: "15px" }}>
                  <div className="Select-wrapp">
                    <Select
                      placeholder="Liste des agents"
                      options={clients?.map((client) => ({
                        value: client.id,
                        label: `${client.firstName} ${client.lastName}`,
                      }))}
                      onChange={(selectedOption) => {
                        const value = selectedOption
                          ? selectedOption.value
                          : null;
                        formik.setFieldValue("agentId", value);
                      }}
                      onBlur={() => formik.setFieldTouched("agentId", true)}
                      value={
                        clients
                          ?.map((client) => ({
                            value: client.id,
                            label: `${client.firstName} ${client.lastName}`,
                          }))
                          .find(
                            (option) => option.value === formik.values.agentId
                          ) || null
                      }
                    />
                    {formik.touched.agentId && formik.errors.agentId ? (
                      <div className="text-danger">{formik.errors.agentId}</div>
                    ) : null}
                  </div>
                </Col>
                <Col xs={12} md={6} style={{ marginTop: "15px" }}>
                  <Form.Group className="" controlId="formBasicAgent">
                    <div className="Select-wrapp">
                      <Select
                        placeholder="Liste des grilles d’évaluation"
                        options={datagrilles?.grids?.map((grid) => ({
                          value: grid.id,
                          label: grid.name,
                        }))}
                        onChange={(selectedOption) => {
                          const value = selectedOption
                            ? selectedOption.value
                            : null;
                          formik.setFieldValue("gridId", value);
                        }}
                        onBlur={() => formik.setFieldTouched("gridId", true)}
                        value={
                          datagrilles?.grids
                            ?.map((grid) => ({
                              value: grid.id,
                              label: grid.name,
                            }))
                            .find(
                              (option) => option.value === formik.values.gridId
                            ) || null
                        }
                      />
                      {formik.touched.gridId && formik.errors.gridId ? (
                        <div className="text-danger">
                          {formik.errors.gridId}
                        </div>
                      ) : null}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form.Group>
            <Row className="marginRows">
              <Col xs={12} md={6} style={{ marginTop: "15px" }}>
                <div className="Select-wrapp">
                  <Form.Group>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom-end"
                      className="red-border date-input"
                      selected={formik.values.DateLimite}
                      locale={fr}
                      onChange={(date) =>
                        formik.setFieldValue(
                          "DateLimite",
                          new Date(
                            date.getTime() - date.getTimezoneOffset() * 60000
                          )
                        )
                      }
                      onBlur={() => formik.setFieldTouched("DateLimite", true)}
                      placeholderText="jj/mm/aaaa"
                      customInput={<ExampleCustomInput />}
                      minDate={new Date()}
                    />

                    {formik.touched.DateLimite && formik.errors.DateLimite ? (
                      <div className="text-danger">
                        {formik.errors.DateLimite}
                      </div>
                    ) : null}
                  </Form.Group>
                </div>
              </Col>
              <OverlayTrigger
                key="bottom"
                placement="bottom"
                overlay={
                  formik.values.OrganIsEval ? (
                    <Tooltip
                      data-color="#01A71B"
                      id={`tooltip-bottom`}
                      style={{
                        zIndex: 200000,
                        marginLeft:
                          window.devicePixelRatio === 1.25 ? "7.6%" : "9%",
                        marginTop:
                          window.devicePixelRatio === 1.25 ? "-0.4%" : "-0.4%",
                      }}
                    >
                      <span className="desable-switch_title">Je participe</span>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      data-color="#F00"
                      id={`tooltip-bottom`}
                      style={{
                        zIndex: 200000,
                        marginLeft:
                          window.devicePixelRatio === 1.25 ? "7.6%" : "9%",
                        marginTop:
                          window.devicePixelRatio === 1.25 ? "-0.4%" : "-0.4%",
                      }}
                    >
                      <span className="desable-switch_title">
                        Je ne participe pas
                      </span>
                    </Tooltip>
                  )
                }
              >
                <Col xs={12} md={6} style={{ marginTop: "15px" }}>
                  <div
                    className="participation-field"
                    style={{
                      width:
                        window.devicePixelRatio === 1.25 ? "347.5px" : "446px",
                    }}
                  >
                    <div className="participe-phrase">Je participe</div>
                    <div className="switch-button-participe">
                      <Switch
                        checked={formik.values.OrganIsEval}
                        onChange={() =>
                          formik.setFieldValue(
                            "OrganIsEval",
                            !formik.values.OrganIsEval
                          )
                        }
                        className={clsx(
                          {
                            "activate-switch-boutton":
                              formik.values.OrganIsEval,
                          },
                          {
                            "deactivate-switch-boutton":
                              !formik.values.OrganIsEval,
                          }
                        )}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#5800e2"
                        height={20}
                        width={38}
                      />
                    </div>
                  </div>
                  {formik.touched.OrganIsEval && formik.errors.OrganIsEval ? (
                    <div className="text-danger">
                      {formik.errors.OrganIsEval}
                    </div>
                  ) : null}
                </Col>
              </OverlayTrigger>
            </Row>
          </div>
          <div className="container-buttons-callibrage">
            <Button
              variant="primary"
              className="button-calibrage-submit"
              type="submit"
              disabled={isSaving}
            >
              {isSaving === true ? `Chargement ...` : `Enregistrer`}
            </Button>

            <Button
              variant="primary"
              className="button-annuler-callibrage-nouveau"
              onClick={() => {
                setCloseAnimation(true);
                setTimeout(() => {
                  props.closeCallibrage();
                }, 2000);
              }}
            >
              Annuler
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default Callibrage;
